import React from "react";
import { graphql } from "gatsby";
import Meta from "../components/Meta";
import About from "../components/homepage/About";
import EcoSystem from "../components/EcoSystem";
import EventsDark from "../components/EventsDark";
import Hero from "../components/homepage/Hero";
import GetStarted from "../components/GetStarted";
import Technology from "../components/homepage/Technology";
import UseCases from "../components/homepage/UseCases";
import HeroContainer from "../components/ui/HeroContainer";
import Layout from "../components/ui/Layout";
import Campaign from "../components/homepage/Campaign";
import Gallery from "../components/Gallery";

// On each page, except home the user will be able to configre the background color of the hero section.
// Depending on the background color, the logo on mobile will be black and white
// so maybe:  heroColor: "#FFFFFF", headerWhiteMobile: boolean,
// prop to be passed to Layout if headerWhiteMobile: headerWhiteMobile
// prop to be passed to HeroContainer: backgroundColor={heroColor}

const Homepage = ({ data }) => {
  const {
    seoMeta,
    hero,
    about,
    campaignBadge,
    campaignTitle,
    _rawCampaignbDescription,
    campaignCta,
    campaignImage,
    technology,
    useCases,
    startBuilding,
    ecoSystem,
    events,
    gallery,
  } = data.pageContent;
  return (
    <>
      <Meta data={seoMeta} />
      <Layout>
        <HeroContainer>
          <Hero data={hero} />
        </HeroContainer>
        <About data={about} />
        <Campaign
          data={{
            campaignBadge,
            campaignTitle,
            _rawCampaignbDescription,
            campaignCta,
            campaignImage,
          }}
        />
        <Technology data={technology} />
        <UseCases data={useCases} />
        <GetStarted data={startBuilding} />
        <EcoSystem data={ecoSystem} className="!pt-section" />
        <EventsDark data={events} />
        <Gallery data={gallery} className="pb-0" />
      </Layout>
    </>
  );
};

export const pageQuery = graphql`
  query {
    pageContent: sanityHomePage {
      seoMeta {
        metaTitle
        metaDescription
        ogImage {
          asset {
            url
          }
        }
        noindex
      }
      hero {
        subtitle
        title
        cta1 {
          label
          link
          isExternal
        }
        cta2 {
          label
          link
          isExternal
        }
      }
      about {
        title
        cta {
          label
          link
          isExternal
        }
        list {
          _rawItems(resolveReferences: { maxDepth: 10 })
        }
      }
      campaignBadge
      campaignTitle
      _rawCampaignbDescription(resolveReferences: { maxDepth: 10 })
      campaignCta {
        label
        link
        isExternal
      }
      campaignImage {
        asset {
          gatsbyImageData(fit: FILLMAX)
        }
      }
      technology {
        badge
        headline
        rollups {
          title
          description {
            children {
              text
            }
          }
          cta {
            label
            link
            isExternal
          }
          list {
            _rawItems(resolveReferences: { maxDepth: 10 })
          }
          lottie {
            title
            description {
              children {
                text
              }
            }
            file {
              asset {
                url
              }
            }
          }
        }
        vmBlock {
          title
          description {
            children {
              text
            }
          }
          cta {
            label
            link
            isExternal
          }
          video {
            asset {
              url
            }
          }
          list {
            _rawItems(resolveReferences: { maxDepth: 10 })
          }
        }
      }
      useCases {
        title
        cta {
          link
          label
          isExternal
        }
        cta2 {
          link
          label
          isExternal
        }
        list {
          _rawItems(resolveReferences: { maxDepth: 10 })
        }
      }
      startBuilding {
        badge
        title
        cta1 {
          label
          link
          isExternal
        }
        cta2 {
          label
          link
          isExternal
        }
        buildingSteps {
          title
          _rawContent
          number
          image {
            asset {
              gatsbyImageData(fit: FILLMAX, placeholder: BLURRED)
            }
          }
          cta {
            label
            link
            isExternal
          }
        }
      }
      ecoSystem {
        badge
        title
        _rawDescription(resolveReferences: { maxDepth: 10 })
        cta {
          label
          link
          isExternal
        }
        _rawPartners(resolveReferences: { maxDepth: 15 })
      }
      events {
        title
        isVisibleBlock
        cta {
          label
          link
          isExternal
        }
      }
      gallery {
        title
        image {
          asset {
            gatsbyImageData(fit: FILLMAX, placeholder: BLURRED)
          }
        }
      }
    }
  }
`;

export default Homepage;
